import type { ReasoningTarget } from './InsightGroupDrawer';

// The Insights group the campaign page's Explainability tab is narrowed to.
export const GROUP_PARAM = 'group';
export const GROUP_NAME_PARAM = 'groupName';
export const GROUP_ACTIVITY_PARAM = 'activity';
export const GROUP_PARAMS = [GROUP_PARAM, GROUP_NAME_PARAM, GROUP_ACTIVITY_PARAM];

/** `params` switched to the Explainability tab, narrowed to one group's reasoning. */
export function withReasoningFor(params: URLSearchParams, target: ReasoningTarget): URLSearchParams {
    const next = new URLSearchParams(params);
    next.set('tab', 'explainability');
    next.set(GROUP_PARAM, target.groupIdentifier);
    next.set(GROUP_NAME_PARAM, target.groupName);
    if (target.activityTemplateCode) next.set(GROUP_ACTIVITY_PARAM, target.activityTemplateCode);
    else next.delete(GROUP_ACTIVITY_PARAM);
    return next;
}

/** The campaign page opened on one group's reasoning, for pages outside that campaign. */
export const reasoningPathFor = (projectId: string, target: ReasoningTarget): string =>
    `/analytics/projects/${projectId}/campaign/${target.campaignId}?${withReasoningFor(new URLSearchParams(), target)}`;
